import {
  StyledCategoryDescription,
  StyledCategoryStats,
  StyledPieChart
} from './CategoryStats.style';
import CategoryFilters from './CategoryFilters/CategoryFilters';
import PieChart from './PieChart/PieChart';
import useCategoryPieData from './PieChart/useCategoryPieData';
import { mapCategoryToDescription } from './categories.descriptions';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

const CategoryStats = ({
  selectedCategory,
  categories,
  toggleIssuesDisplay
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const { activeIdx, categoriesPieData } = useCategoryPieData({
    selectedCategory,
    categories
  });

  const CategoryDescription = mapCategoryToDescription[selectedCategory.key];
  const isAutomationsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.automationsViewEnabled
  });

  return (
    <StyledCategoryStats>
      <StyledCategoryDescription>
        {CategoryDescription && (
          <CategoryDescription isAutomationsEnabled={isAutomationsEnabled} />
        )}
      </StyledCategoryDescription>
      <StyledPieChart>
        <PieChart data={categoriesPieData} activeIdx={activeIdx} />
      </StyledPieChart>
      <CategoryFilters
        selectedCategory={selectedCategory}
        toggleIssuesDisplay={toggleIssuesDisplay}
      />
    </StyledCategoryStats>
  );
};

export default CategoryStats;
